import script from "./media-viewer.vue?vue&type=script&setup=true&lang=js"
export * from "./media-viewer.vue?vue&type=script&setup=true&lang=js"

import "./media-viewer.vue?vue&type=style&index=0&id=ad88608a&scoped=true&lang=css"
import "./media-viewer.vue?vue&type=style&index=1&id=ad88608a&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad88608a"]])

export default __exports__